import type { Epic } from '../../index.ts'
import { visualizationSlice } from '../../Slice/Visualization/VisualizationSlice.ts'
import { catchError, filter, map, of, switchMap } from 'rxjs'
import { get } from '../../../Repository'
import { Environment } from '../../../environment.ts'
import type { Trait } from '../../Slice/Visualization/VisualizationSliceTypes.ts'

export const traitLoadingEpic: Epic = (action$, _state$, { [visualizationSlice.name]: visualization }) =>
  action$.pipe(
    filter(visualization.loadTraits.match),
    switchMap((action) => {
      const scopeId = action.payload?.scopeId
      /* an unresolved id would go into the path as the string "undefined"; the reducer has already
       * marked the load pending, so this still has to end in a terminal action or the panel spins */
      if (!scopeId) return of(visualization.traitStateError({ error: new Error('loadTraits without a scope id') }))

      return get<object, Trait[]>(`${Environment.VIS_URL}/krona/${scopeId}/traits`).pipe(
        map((response) => {
          const groupSet = new Set<string>()
          const traitMap = response.reduce(
            (previous, current) => {
              groupSet.add(current.traitgroup)
              if (current.traitname in previous) {
                previous[current.traitname].push(current)
              } else {
                previous[current.traitname] = [current]
              }
              return previous
            },
            {} as Record<string, Trait[]>
          )

          return visualization.traitsLoaded({ traits: response, traitMap, traitGroups: groupSet.values().toArray(), scopeId })
        }),
        catchError((error) => of(visualization.traitStateError({ error, scopeId })))
      )
    })
  )
